import { render } from "./ViewerResourceVideo.vue?vue&type=template&id=31a38cd8&scoped=true"
import script from "./ViewerResourceVideo.vue?vue&type=script&lang=js"
export * from "./ViewerResourceVideo.vue?vue&type=script&lang=js"

import "./ViewerResourceVideo.vue?vue&type=style&index=0&id=31a38cd8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a38cd8"]])

export default __exports__